import CircularProgress from '@mui/material/CircularProgress';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

interface ProcessingStateProps {
  title: string;
  description: string;
}

const ProcessingState = ({ title, description }: ProcessingStateProps) => {
  return (
    <Stack
      alignItems="center"
      spacing={2}
      py={1}
      data-testid="processing-state"
    >
      <CircularProgress size={34} />

      <Typography variant="h3">{title}</Typography>

      <Typography color="text.secondary" textAlign="center">
        {description}
      </Typography>
    </Stack>
  );
};

export default ProcessingState;
